import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { TriggerListContent } from 'widgets/TriggerList/ui/TriggerListContent'
import {
  type ITriggerListStoreProps,
  TriggerListStore,
} from 'widgets/TriggerList/store/triggerListStore'
import { TriggerListContext } from 'widgets/TriggerList/context/context'

type ITriggerListProps = {
  storeProps: ITriggerListStoreProps
}

export const TriggerList = observer(({ storeProps }: ITriggerListProps) => {
  const entities = useEntitiesContext()
  const [store] = useState(() => new TriggerListStore(storeProps, entities))
  useEffect(() => {
    entities.inboxesStore.fetchInboxes()

    return store.clearReactions
  }, [])

  return (
    <TriggerListContext.Provider value={store}>
      <TriggerListContent />
    </TriggerListContext.Provider>
  )
})
